import styled from 'styled-components'

export default styled.main`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
  padding-left: 24px;
  max-height: 100vh;
  overflow: auto;
  max-width: 100%;
  width: 100%;
  padding-bottom: 12px;
`
